import { get } from "lodash"

function extractFinancialMetrics(value, suffix) {
  return {
    ...get(value, `values.marketValue${suffix}`, {}),
    // marketValue.economicExposure is the positionEconomicExposure + baseEconomicExposure and that's not what we want here
    economicExposure: get(value, `values.marketValue${suffix}.positionSetEconomicExposure`),
    positionPercentEquity: get(value, `values.composition${suffix}.positionSetEconomicExposure`),
    activePercentEquity: get(value, `values.composition${suffix}.economicExposure`),
    basePercentEquity: get(value, `values.composition${suffix}.baseEconomicExposure`),
  }
}

function buildTradesContributor(child, childKey, hasTrades) {
  const original = getContributorDetails(child, false)
  const target = getContributorDetails(child, hasTrades)

  return {
    ...child,
    ...target,
    original,
    modelProviderId: childKey,
  }
}

export function getContributorDetails(value, isTarget) {
  const valueKeys = value?.values ? Object.keys(value.values) : []

  // for original mode, when there are trades,
  // fallback to the original values which don't have a suffix
  const suffix = isTarget && valueKeys.some(key => key.endsWith("-rebalanced"))
    ? "-rebalanced"
    : ""

  return extractFinancialMetrics(value, suffix)
}

export function getTradesContributors(data, hasTrades) {
  const children = get(data, "children", {})

  return Object.entries(children).map(([childKey, child]) =>
    buildTradesContributor(child, childKey, hasTrades),
  )
}
